import request from "../../untils/request.js"


//分页
export const getShiftEndStatisticsPage = (params) => {
    return request.get('/outpatient/shhar/page',{params})
}

export const getShiftEndStatisticsOneById = (id) => {
    return request.get(`/outpatient/shhar/${id}`)
}

export default{
}

